import axios from 'axios';
import { auth, db } from './firebase';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
//import { ref, deleteObject } from 'firebase/storage';

// Function to upload an image and save its reference in Firestore
export const saveImage = async (imageReferenceURL) => {
  const user = auth.currentUser;
  const uid = user.uid;

  const uploadURL = process.env.REACT_APP_UPLOAD_IMAGE_API;
  try {
    console.log("sending data to backend");
    const data = {
      image_url: imageReferenceURL,
      user_id: uid,
    };
    // Access token is expired, refresh tokens
    const response = await axios.post(uploadURL, data);
    console.log("successful response");
    return response;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

export const fetchImageURL = async (user) => {
  try {
    if (!user) {
      throw new Error('User not authenticated');
    }

    const userId = user.uid;
    const usersCollectionRef = doc(db, 'users', userId);
    const usersSnapshot = await getDoc(usersCollectionRef);

    if (usersSnapshot.exists()) {
      const userData = usersSnapshot.data();
      if (userData.image_urls && Array.isArray(userData.image_urls)) {
        // Return the array of image URLs
        return userData.image_urls;
      } else {
        // Return null if image_urls field is missing or not an array
        return null;
      }
    }

    return null;
  } catch (error) {
    console.error('Error fetching image URLs:', error);
    throw error;
  }
};


// Function to delete the image from Firebase Storage and remove its reference from Firestore
export const deleteImage = async (imageUrl) => {
  try {
    const user = auth.currentUser;
    const userId = user.uid;
    const usersCollectionRef = doc(db, 'users', userId);
    const usersSnapshot = await getDoc(usersCollectionRef);

    if (usersSnapshot.exists()) {
      const userData = usersSnapshot.data();
      if (userData.image_urls && Array.isArray(userData.image_urls)) {
        // Remove the imageURL from the array
        const updatedImageUrls = userData.image_urls.filter(url => url !== imageUrl);

        // Update the image_urls field in Firestore
        await updateDoc(usersCollectionRef, { image_urls: updatedImageUrls });
        console.log('Image deleted successfully.');
      } else {
        console.error('No image URLs found in Firestore for user:', userId);
      }
    } else {
      console.error('User document does not exist in Firestore:', userId);
    }
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error;
  }
};
